module.exports = __webpack_public_path__ + "img/dooball.dbd45fad.png";